
import Hide from '@/components/dealer/hide.vue'
export default {
  components: {
    Hide
  },
  inject: ['detail', 'hotEmployee'],
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    const _showLength = 6
    const _showLengthForRemen = 6
    const list = this.type == '2' ? this.detail?.hotOfficerList?.slice(0, _showLengthForRemen) : this.detail?.otherOfficerList
    const _initDataList = list?.slice(0, this.type == '2' ? _showLength : _showLength)

    return {
      showLength: 6,
      showLengthForRemen: 6,
      isShow: false,
      isUnfold: false,
      initDataList: _initDataList,
      widthType: 'pc',
      pageSize: 10,
      pageIndex: 0
    }
  },
  computed: {
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
  },
  created() {},
  mounted() {
    this.getelewidth()
    this.initData()
    const that = this
    window.addEventListener('resize', () => {
      that.getelewidth()
      that.initData()
    })
    console.log('员工 + 热门高管')
  },
  methods: {
    openggfn(item) {
      this.$refs.hideref.open(item.officerId, 3, () => {
        window.open(`/${this.$store.state.LanguageCode}/employee/${item?.officerId}.html`)
      })
    },
    initData() {
      // console.log('触发initData')
      const list = this.type == '2' ? this.detail?.hotOfficerList?.slice(0, this.showLengthForRemen) : this.detail?.otherOfficerList
      this.initDataList = list?.slice(0, this.type == '2' ? this.showLengthForRemen : this.showLength)
      this.isShow = this.type == '2' ? false : list.length > this.showLength
      this.isUnfold = false
      this.pageIndex = 0
    },
    moreClick() {
      this.isUnfold = !this.isUnfold
      const list = this.type == '2' ? this.detail?.hotOfficerList : this.detail?.otherOfficerList
      if (!this.isUnfold) {
        this.pageIndex = 0
        this.initDataList = list.slice(0, this.showLength)
      } else {
        this.pageIndex++
        this.initDataList = list?.slice(0, this.showLength * this.pageSize * (this.pageIndex == 0 || this.pageIndex == 1 ? 1 : this.pageIndex))
      }
    },
    getelewidth() {
      const ele = document.documentElement.clientWidth
      if (ele >= 1199 - this.getScrollbarWidth()) {
        this.widthType = 'pc'
        this.showLength = 6
      } else if (ele >= 999 - this.getScrollbarWidth() && ele < 1199 - this.getScrollbarWidth()) {
        this.widthType = 'lg'
        this.showLength = 4
      } else if (ele >= 799 - this.getScrollbarWidth() && ele < 999 - this.getScrollbarWidth()) {
        this.widthType = 'md'
        this.showLength = 4
      } else {
        this.widthType = 'sm'
        this.showLength = 4
      }
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    }
  }
}
